<template>
  <b-container class="h-100">
    <transition name="slide-fade">
      <b-row class="h-100">
        <b-col
          class="d-flex flex-column justify-content-center login-wrapper--right-form"
        >
          <div class="d-flex">
            <b-img src="/img/logo.svg" fluid />
          </div>

          <div class="mt-4">
            <h3 class="font-weight-bold">Send Reset Code</h3>
            <p class="mt-3">
              Enter your email address to receive an email with a code to reset
              your password:
            </p>
          </div>

          <b-form @submit.prevent="onSubmit">
            <b-row no-gutters>
              <b-col cols="12">
                <b-form-group id="input-group-1">
                  <label class="font-weight-bold">Email Address</label>
                  <b-form-input
                    id="input-1"
                    v-model="form.email"
                    class="form-control effect-26"
                    :class="form.email ? 'has-content' : ''"
                    type="email"
                    required
                    autofocus
                    placeholder="Enter email address"
                  ></b-form-input>
                </b-form-group>
                <div class="input-error" v-if="form.$getError('email')">
                  {{ form.$getError('email')[0] }}
                </div>

                <!-- API Error Message -->
                <div class="form-message mb-4" v-show="form.$errorMessage">
                  {{ form.$errorMessage }}
                </div>
              </b-col>

              <b-col cols="12">
                <div class="ta-right">
                  <b-button class="form-button" type="submit" variant="primary">
                    <b-spinner small v-if="form.$busy"></b-spinner>
                    <div v-else>SEND</div>
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </b-form>
        </b-col>
      </b-row>
    </transition>
  </b-container>
</template>

<script>
import Form from '@/utils/form'

export default {
  data() {
    return {
      form: new Form({
        email: ''
      })
    }
  },

  methods: {
    async onSubmit(evt) {
      this.form.$busy = true
      await this.$api
        .post('auth/forgot-password', {
          username: this.form.email
        })
        .then(({ data }) => {
          this.form.$busy = false
          this.$router.replace({
            name: 'auth.reset-password-page',
            params: {
              email: this.form.$data().email
            }
          })
        })
        .catch(error => {
          this.form.$handleError(error)
        })
    }
  },

  watch: {
    'form.email'() {
      this.form.$clearError('email')
    }
  }
}
</script>
